<template>
  <div id="honor_lunbo" :class="active != -1 ? 'active' : ''">
    <div id="lunbo_begin">
      <div
        v-for="(item, i) in picList"
        :key="i"
        class="imgbox"
        :class="active == i ? 'active' : ''"
      >
        <img :src="item.img" @mouseenter="stopmove(i)" @mouseleave="move(i)" />
        <div class="textbox">
          <div class="Demibold title">
            {{ language == "zh" ? item.title : item.titleEn }}
          </div>
          <div class="heng" v-if="item.content"></div>
          <div class="Regular nr"  v-if="item.content">
            {{ language == "zh" ? item.content : item.contentEn }}
          </div>
        </div>
      </div>
    </div>
    <div id="lunbo_end">
      <div
        v-for="(item, i) in picList"
        :key="i"
        class="imgbox"
        :class="active1 == i ? 'active' : ''"
      >
        <img :src="item.img" @mouseenter="stopmove1(i)" @mouseleave="move1(i)" />
        <div class="textbox">
          <div class="Demibold title">
            {{ language == "zh" ? item.title : item.titleEn }}
          </div>
          <div class="heng" v-if="item.content"></div>
          <div class="Regular nr"  v-if="item.content">
            {{ language == "zh" ? item.content : item.contentEn }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      stopBanner: false,
      MyMar: null,
      speed: 40, // 图片滚动速度，数值越大，速度越慢
      active: -1,
      active1: -1,
      picList: [],
      picList1: [
        {
          img: "../../static/img/CompanyE&E1.jpg",
          active: false,
        },
        {
          img: "../../static/img/CompanyE&E2.jpg",
          active: false,
        },
        {
          img: "../../static/img/CompanyE&E3Main.jpg",
          active: false,
        },
        {
          img: "../../static/img/CompanyE&E4.jpg",
          active: false,
        },
      ],
    };
  },
  mounted() {
    this.getInfo();
    this.ScrollImgLeft();
  },
  beforeDestroy() {
    // 销毁定时器，否则可能导致重载此组件时会有多个定时器同时执行，使得滚动变快
    window.clearTimeout(this.timer);
    clearInterval(this.timer);
    this.timer = null;
  },
  created() {
    this.move();
  },
  methods: {
    ScrollImgLeft() {
      var that = this;

      // let lunbo_begin = document.getElementById("lunbo_begin");
      // let lunbo_end = document.getElementById("lunbo_end");

      // let honor_lunbo = document.getElementById("honor_lunbo");
      // lunbo_end.innerHTML = lunbo_begin.innerHTML; // 图片衔接
      // 滚动方法
      // function Marquee() {
      // console.log(lunbo_begin.offsetWidth )
      // console.log( honor_lunbo.scrollLeft)
      // console.log(lunbo_begin.offsetWidth - honor_lunbo.scrollLeft <= 0)
      // if (lunbo_begin.offsetWidth - honor_lunbo.scrollLeft <= 0)
      //   honor_lunbo.scrollLeft -= lunbo_begin.offsetWidth;
      // else honor_lunbo.scrollLeft++;

      // console.log( '====='+honor_lunbo.scrollLeft)
      // console.log('lunbo_begin.scrollWidth=='+lunbo_begin.scrollWidth )
      // console.log( 'honor_lunbo.scrollLeft=='+honor_lunbo.scrollLeft)
      //   console.log("Marquee=="+that.stopBanner)
      //     if (honor_lunbo.scrollLeft >= lunbo_begin.scrollWidth) {
      //       honor_lunbo.scrollLeft = 0;
      //     } else {
      //       if (!that.stopBanner) {
      //         honor_lunbo.scrollLeft++;
      //     }
      //   }
      // }
      // this.MyMar = setInterval(this.Marquee, this.speed);
      // 鼠标移入，滚动暂停
      // honor_lunbo.onmouseover = function () {
      //   this.stopBanner = true;
      //   console.log("onmouseover=="+this.stopBanner)
      //   clearInterval(this.MyMar);
      // };
      // 鼠标移出，滚动继续
      // honor_lunbo.onmouseout = function () {
      //   this.stopBanner = false;
      //   console.log("onmouseout=="+this.stopBanner)
      //   this.MyMar = setInterval(this.Marquee, this.speed);
      // };
      // this.move();
    },
    Marquee() {
      let lunbo_begin = document.getElementById("lunbo_begin");
      let lunbo_end = document.getElementById("lunbo_end");

      let honor_lunbo = document.getElementById("honor_lunbo");
      // lunbo_end.innerHTML = lunbo_begin.innerHTML; // 图片衔接
      // console.log("Marquee==" + this.stopBanner);
      if (lunbo_begin && honor_lunbo) {
        if (honor_lunbo.scrollLeft >= lunbo_begin.scrollWidth) {
          honor_lunbo.scrollLeft = 0;
        } else {
          // if (!this.stopBanner) {
          honor_lunbo.scrollLeft++;
          // }
        }
      }
    },
    reset() {
      let honor_lunbo = document.getElementById("honor_lunbo");
      honor_lunbo.scrollLeft = 0;
    },
    getInfo() {
      this.$http.get("hdbs/api/publicity/company/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.picList = response.data.page.list.concat(
              response.data.page.list
            );
            // this.picList1 = response.data.page.list.contact(response.data.page.list);
          }
        }.bind(this)
      );
    },
    //移动
    move(i) {
      this.timer = setInterval(this.Marquee, 20);
      this.leave(i)
    },
    //鼠标悬停时停止移动
    stopmove(i) {
      clearInterval(this.timer);
      this.enter(i)
    },
    //移动
    move1(i) {
      this.timer = setInterval(this.Marquee, 20);
      this.leave1(i)
    },
    //鼠标悬停时停止移动
    stopmove1(i) {
      clearInterval(this.timer);
      this.enter1(i)
    },
    enter(i) {
      this.active = i;
    },
    leave() {
      this.active = -1;
    },
    enter1(i) {
      this.active1 = i;
    },
    leave1() {
      this.active1 = -1;
    },
  },
};
</script>
<style lang="stylus" scoped>
#honor_lunbo {
  margin: 0;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  //height: 100vh;
}

.imgbox {
  width: 17vw;
  height: 11.3vw;
  margin-right: 2vw;
  border-radius: 6px;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;

  .textbox {
    width: 17vw;
    opacity: 0;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;

    .title {
      font-size: 2.4rem;
      color: var(--mainBlue);
      white-space: break-spaces;
      text-align: right;
      margin: 3rem 0 1rem 0;
    }

    .nr {
      font-size: 2.1rem;
      margin-top: 1rem;
      color: var(--mainGary);
      white-space: break-spaces;
      text-align: right;
    }
  }
}

.imgbox.active {
  width: 27.2vw;
  height: 28.1vw;
  margin-right: 2vw;
  border-radius: 6px;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-bottom: 10vw;

  .textbox {
    opacity: 1;
    width: 27.2vw;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
  }
}

.imgbox:hover {
  width: 27.2vw;
  height: 28.1vw;
  margin-right: 2vw;
  border-radius: 6px;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-bottom: 10vw;

  .textbox {
    opacity: 1;
    width: 27.2vw;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
  }
}

img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.heng {
  height: 1px;
  width: 100%;
  background: var(--mainGary);
}

#lunbo_begin, #lunbo_end {
  display: inline-flex;
}

@media screen and (max-width: 1200px) {
  .imgbox .textbox .nr {
    font-size: 1.4rem;
  }

  .imgbox .textbox .title {
    font-size: 1.7rem;
  }

  .imgbox {
    width: 30vw;
    height: auto;
  }

  .imgbox:hover {
    //height: 30vh;
    width: 50vw;
    .textbox {
      width: 50vw;
      .title{
        margin:0 
      }
    }
  }

  .imgbox img {
    height: auto;
  }

  .imgbox.active {
    //height: 50vh;
    width: 50vw;
    .textbox {
      width: 50vw;
      .title{
        margin:0 
      }
    }
  }

  #honor_lunbo {
    margin-top: 3rem;
  }
}

@media screen and (max-height: 1000px) {
  #honor_lunbo .imgbox {
    // width: 14vw;
    // height: 10vw;
  }

  #honor_lunbo .imgbox.active {
    // width: 18vw;
    // height: 13vw;
    // padding-bottom: 1vw;
    .textbox {
      // width: 18vw;
    }
  }

  #honor_lunbo .imgbox:hover {
    // width: 18vw;
    // height: 13vw;
    // padding-bottom: 1vw;
    .textbox {
      // width: 18vw;
    }
  }

  #honor_lunbo .imgbox .textbox {
    // width: 14vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SwiperBox.vue